<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de proyectos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-if="consultar" @click="exportarExcel()" class="btn-success btn--bigger" type="button">
            <i class="fa fa-file-excel-o"></i>
            <span>Excel</span>
          </button>
          <button v-if="consultar" @click="botonConsultar()" class="btn-info btn--bigger" type="button">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="form-group">
                <div class="select2-field">
                  <v-select
                    @input="inputPersona"
                    @search="onSearchPersona"
                    :tooltip="selectedPersona?selectedPersona.nombre:null"
                    placeholder="Busque y seleccione..."
                    id="persona"
                    v-model="selectedPersona"
                    :options="optionPersonas"
                    label="nombre"
                  ></v-select>
                  <label for="persona">Cliente</label>
                </div>
                <button @click="buscarPersona()" class="btn-info" type="button">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-group">
              <div class="form-inline">
                <label>
                  <strong>Fecha inicio</strong>
                </label>
                <label>
                  <input type="radio" v-model="form.tipo_fecha_inicio" value="T"/>
                  <span>A la fecha</span>
                </label>
                <label>
                  <input type="radio" v-model="form.tipo_fecha_inicio" value="P"/>
                  <span>Personalizado</span>
                </label>
                <div v-show="form.tipo_fecha_inicio == 'P'" class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      id="fecha_desde_inicio"
                      v-model="form.fecha_desde_inicio"
                      locale="es"
                      only-datetime
                      no-label
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm"
                      label="Seleccione fecha..."
                    />
                    <label>Desde</label>
                    <span v-if="errores.fecha_desde_inicio" class="helper-text text-danger" slot="helper">
                      {{ errores.fecha_desde_inicio[0] }}
                    </span>
                  </div>
                </div>
                <div v-show="form.tipo_fecha_inicio == 'P'" class="form-field">
                  <div class="datepicker-field datepicker-field--stretch">
                    <VueCtkDateTimePicker
                      id="fecha_hasta_inicio"
                      v-model="form.fecha_hasta_inicio"
                      locale="es"
                      only-datetime
                      no-label
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD HH:mm"
                      formatted="YYYY-MM-DD HH:mm"
                      label="Seleccione fecha..."
                    />
                    <label>Hasta</label>
                    <span v-if="errores.fecha_hasta_inicio" class="helper-text text-danger" slot="helper">
                      {{ errores.fecha_hasta_inicio[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-7">
            <div class="form-inline">
              <label>
                <strong>Filtros por estado</strong>
              </label>
              <label>
                <input type="radio" v-model="form.estado" value="P"/>
                <span>Pendiente</span>
              </label>
              <label>
                <input type="radio" v-model="form.estado" value="FA"/>
                <span>Facturado</span>
              </label>
              <label>
                <input type="radio" v-model="form.estado" value="FF"/>
                <span>Finalizado</span>
              </label>
              <label>
                <input type="radio" v-model="form.estado" value="I"/>
                <span>Anulado</span>
              </label>
              <label>
                <input type="radio" v-model="form.estado" value="T"/>
                <span>Todos</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="table-responsive">
          <vue-good-table
            :columns="[
              {
                label: 'Código',
                field: 'codigo',
              },
              {
                label: 'Cliente',
                field: 'nombre_persona',
              },
              {
                label: 'Proyecto',
                field: 'nombre',
              },
              {
                label: 'Descripción',
                field: 'descripcion',
              },
              {
                label: 'Fecha Inicio',
                field: 'fecha_inicio',
              },
              {
                label: 'Estado',
                field: 'nombre_estado',
              },
              {
                label: 'Comprobantes',
                field: 'comprobantes',
              },
              {
                label: 'Costos por Proyecto',
                field: 'costos_proyectos',
              },
            ]"
            mode="remote"
            :pagination-options="{
              enabled: true,
              perPage: 10,
              nextLabel: 'siguiente',
              prevLabel: 'anterior',
              rowsPerPageLabel: 'Registros por página',
              ofLabel: 'de',
              allLabel: 'Todo',
              dropdownAllowAll: true,
              perPageDropdownEnabled: true,
              perPageDropdown: [10, 20, 30, 40, 50]
            }"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            ref="listaReporteProyectos"
            :rows="registros"
            :search-options="{
              enabled: false,
              placeholder: 'Buscar...'
            }"
            styleClass="vgt-table"
          >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'comprobantes'">
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th># Comp.</th>
                      <th>Cliente</th>
                      <th>F. Emisión</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="comprobante in props.row.comprobantes" :key="comprobante.id_comprobante">
                      <td>{{ comprobante.numero_documento }}</td>
                      <td>{{ comprobante.nombre_cliente }}</td>
                      <td>{{ moment(comprobante.fecha_emision).format('YYYY-MM-DD') }}</td>
                    </tr>
                    <tr v-show="props.row.comprobantes.length === 0">
                      <td colspan="3">
                        <strong>No hay comprobantes.</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </span>
            <span v-else-if="props.column.field == 'costos_proyectos'">
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Descripción</th>
                      <th>Fecha</th>
                      <th>Valor</th>
                      <th>Observación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="costo in props.row.costos_proyectos" :key="costo.id">
                      <td>{{ costo.descripcion }}</td>
                      <td>{{ moment(costo.fecha).format('YYYY-MM-DD') }}</td>
                      <td>{{ moneyFormat(costo.valor) }}</td>
                      <td>{{ costo.observacion }}</td>
                    </tr>
                    <tr v-show="props.row.costos_proyectos.length === 0">
                      <td colspan="4">
                        <strong>No hay costos por proyecto.</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <modal width="55%" height="auto" name="listaPersonas" scrollable>
      <lista-personas tipoFiltro="C" :filterStatus="false" @selected="seleccionarPersona" @consultar="consultarPagina"/>
    </modal>
  </div>
</template>
<script>
export default {
  props: {
    consultar: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      moment,
      moneyFormat,
      optionPersonas: [],
      selectedPersona: null,
      registros: [],
      form: {
        tipo_fecha_inicio: 'T',
        fecha_desde_inicio: '',
        fecha_hasta_inicio: '',
        persona_id: '',
        estado: 'T',
        pagination: {
          from: 0,
          last_page: 0,
          current_page: 1,
          per_page: 10,
          to: 0,
          total: 0,
          dropdown: false,
        },
      },
      errores: {
        fecha_desde_inicio: undefined,
        fecha_hasta_inicio: undefined
      }
    }
  },
  methods: {
    exportarExcel: function(){
      let urlApi = `${url}/reporte-proyectos/?exportar=true&tipo=E&`;
      let query = Object.keys(this.form)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(this.form[k]))
        .join('&');
      window.open(urlApi + query, '_blank');
    },
    onPageChange: function(param){
      this.consultarPagina(param);
    },
    onPerPageChange: function(param){
      param = Object.assign({}, param, {dropdown: true});
      this.consultarPagina(param);
    },
    inputPersona: function(){
      if(this.selectedPersona)
        this.form.persona_id = this.selectedPersona.id;
      else{
        this.form.persona_id = '';
        this.selectedPersona = null;
      }
    },
    seleccionarPersona: function(persona){
      this.selectedPersona = persona;
      this.form.persona_id = persona.id;
      this.$modal.hide('listaPersonas');
    },
    buscarPersona: function(){
      this.$modal.show('listaPersonas');
    },
    onSearchPersona: function(search, loading) {
      if(search.length) {
        loading(true);
        this.searchingPersona(loading, search, this);
      }
    },
    searchingPersona: _.debounce((loading, search, vm) => {
      fetch(`${url}/consultar-personas/?search=${search}&es_cliente=S`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(response => response.json()).then(data => {
        vm.optionPersonas = data;
        loading(false);
      });
    }, 350),
    limpiarErrores: function(){
      this.errores.fecha_desde_inicio = undefined;
      this.errores.fecha_hasta_inicio = undefined;
    },
    validaciones: function(){
      this.limpiarErrores();
      let error = false;
      if(this.form.tipo_fecha_inicio == 'P'){
        if(this.form.fecha_desde_inicio == ''){
          this.errores.fecha_desde_inicio = ['El campo fecha desde es obligatorio.'];
          error = true;
        }
        if(this.form.fecha_hasta_inicio == ''){
          this.errores.fecha_hasta_inicio = ['El campo fecha hasta es obligatorio.'];
          error = true;
        }
        if(moment(this.form.fecha_desde_inicio, 'YYYY-MM-DD HH:mm').isAfter(moment(this.form.fecha_hasta_inicio, 'YYYY-MM-DD HH:mm'))){
          swal.fire('Aviso', 'El campo fecha desde debe ser menor a la fecha hasta.', 'warning');
          return true;
        }
      }
      return error;
    },
    resetPaginate: function(){
      this.form.pagination.from = 0;
      this.form.pagination.last_page = 0;
      this.form.pagination.current_page = 1;
      this.form.pagination.per_page = 10;
      this.form.pagination.to = 0;
      this.form.pagination.total = 0;
      this.form.pagination.dropdown = false;
    },
    consultarPagina: async function(param){
      this.form.pagination.current_page = param.currentPage;
      this.form.pagination.per_page = param.currentPerPage;
      this.form.pagination.dropdown = param.dropdown?true:false;
      await this.consultarLista();
    },
    consultarLista: async function(){
      await axios.get(url+ '/reporte-proyectos', {params: this.form}).then(response => {
        let data = response.data;
        this.registros.splice(0, this.registros.length, ...data.info.data);
      });
    },
    botonConsultar: async function(){
      if(this.validaciones())
        return;
      this.resetPaginate();
      this.registros.splice(0, this.registros.length);
      await this.consultarLista();
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteProyectos.vue